import React from 'react';
import styles from './PendingDeposits.module.css';
import { CryptoDepositTravelRule, depositCryptoState, TravelRuleType } from '@/types/crypto';
import PendingDepositsItem from '../PendingDepositsItem/PendingDepositsItem';
import { IonCol, IonRow, IonText } from '@ionic/react';
import { useTranslation } from 'react-i18next';

type Props = {
  allTRCryptoDeposits: CryptoDepositTravelRule[];
  handleInitiateTravelRule: (value: boolean, cryptoData: depositCryptoState, type?: TravelRuleType) => void;
};

const PendingDeposits: React.FC<Props> = ({ allTRCryptoDeposits, handleInitiateTravelRule }) => {
  const { t } = useTranslation();

  return (
    <section className={styles.titleWrapper}>
      <IonRow>
        <IonCol size="8" className={styles.titleContainer}>
          <IonText className={styles.title}>{t('wallet.deposits.crypto.pending')}</IonText>
          <IonText className={styles.description} color={'medium'}>
            {t('wallet.deposits.crypto.travelRule.description')}
          </IonText>
        </IonCol>
      </IonRow>
      <div className={styles.wrapper}>
        {allTRCryptoDeposits.map((deposit) => (
          <PendingDepositsItem
            key={deposit.uuid}
            depositItem={deposit}
            handleInitiateTravelRule={handleInitiateTravelRule}
          />
        ))}
      </div>
    </section>
  );
};

export default React.memo(PendingDeposits);
